import { clearChatResultsGeneratedAt } from "./chatResultsGeneratedAtStore";
import { clearPickSource } from "./pickSourceStore";
import { clearShopTravelResultsExpiry } from "./shopTravelResultsExpiryStore";

export function clearChatBookingOrigin(): void {
  if (typeof window === "undefined") return;
  clearPickSource("hotel", "flight");
  // Also drop the carried chat-results 30-min TTL timestamps — they're only
  // meaningful for a chat-originated booking, so a fresh Shop Travel search
  // must not inherit a stale (or any) chat timestamp.
  clearChatResultsGeneratedAt();
  // And drop any prior Shop Travel responseExpiredAt deadline — the fresh
  // Shop Travel search about to run will re-capture its own.
  clearShopTravelResultsExpiry();
}
